module.exports = __webpack_public_path__ + "static/media/check_new.98f474ae.svg";